<template>
  <div class="box_2 flex-col" style="align-items: flex-start;">
    <span class="text-group_1" v-html="content"></span>
    <div class="section_9 flex-col" style="margin-top: 16px;">
      <div class="pdf-preview" v-if="pdfUrl">
        <iframe
          :src="pdfUrl"
          width="100%"
          height="800px"
          style="border: 1px solid #ddd; border-radius: 4px;"
          title="PDF预览"
        ></iframe>
      </div>
      <div class="image-wrapper_1 flex-col" style="margin-top: 16px;" v-if="showImageWrapper">
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          :src="img('SketchPng33e6061372a0b8e0aa0dad9bdce6bd1c8fbe39d3927584658efa75311aee57ba.png')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanhuDetailContent',
  props: {
    content: {
      type: String,
      default: ''
    },
    pdfUrl: {
      type: String,
      default: ''
    },
    showImageWrapper: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    img(name) {
      return require(`../views/lanhu_wenzhangxiangqing/assets/img/${name}`);
    }
  }
}
</script>

<style scoped>
/* PDF预览样式 */
.pdf-preview { margin-top: 16px; padding: 10px; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }
.pdf-preview iframe { border: none; border-radius: 4px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); }

/* 文字内容样式优化 */
.text-group_1 {
  line-height: 1.8 !important;
  color: #333 !important;
  font-size: 16px !important;
  text-align: justify !important;
  word-spacing: 2px !important;
  letter-spacing: 0.5px !important;
}

/* 段落样式 */
.text-group_1 p {
  margin-bottom: 20px !important;
  padding: 0 !important;
  text-indent: 2em !important;
  line-height: 1.8 !important;
}

/* 标题样式 */
.text-group_1 strong {
  color: #215195 !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  display: block !important;
  margin-bottom: 15px !important;
  text-indent: 0 !important;
  line-height: 1.6 !important;
}

/* 首段不缩进 */
.text-group_1 p:first-child {
  text-indent: 0 !important;
}

/* 响应式文字大小 */
@media (max-width: 768px) {
  .text-group_1 {
    font-size: 15px !important;
    line-height: 1.7 !important;
  }
  
  .text-group_1 strong {
    font-size: 17px !important;
  }
}

@media (max-width: 480px) {
  .text-group_1 {
    font-size: 14px !important;
    line-height: 1.6 !important;
  }
  
  .text-group_1 strong {
    font-size: 16px !important;
  }
}
</style>
<!-- 复用页面样式定义（非 scoped，确保类名在子组件内生效） -->
<style lang="css" src="../views/lanhu_wenzhangxiangqing/assets/index.css"></style>